var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChefsHat21086(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.519 82.867 V 64.919 V 52.967",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(50,75,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.481 52.967 v 11.952 v 17.948",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(50,75,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.483 62.755 C 81.525 60.391 89 51.373 89 40.61 c 0 -12.332 -9.818 -22.347 -22.061 -22.715 C 64.325 8.216 55.506 1.084 45 1.084 S 25.675 8.216 23.061 17.895 C 10.818 18.263 1 28.278 1 40.61 c 0 10.764 7.475 19.781 17.517 22.145 l 0.002 20.113 h 52.963 L 71.483 62.755 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(242,242,242)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.939 17.895 c -0.081 -0.299 -0.185 -0.587 -0.278 -0.881 c -4.061 0.03 -1.881 1.074 -5.221 2.887 c 1.459 -0.339 -3.027 -0.536 -1.464 -0.536 c 11.421 0 20.607 9.572 19.972 21.132 c -0.558 10.157 -8.914 18.409 -19.076 18.855 c -3.122 0.137 -6.093 -0.445 -8.764 -1.593 c -0.853 -0.366 -1.572 0.733 -0.868 1.339 c 4.189 3.608 9.64 5.79 15.603 5.79 c 1.588 0 3.138 -0.158 4.64 -0.453 l 0 -1.68 C 81.525 60.391 89 51.373 89 40.61 C 89 28.278 79.182 18.263 66.939 17.895 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.199 18.075 c -0.743 -0.096 -1.497 -0.157 -2.26 -0.18 C 64.325 8.216 55.506 1.084 45 1.084 c -1.304 0 -2.582 0.111 -3.825 0.322 c 10.332 1.545 18.115 10.89 17.101 21.866 c -0.873 9.449 -8.446 17.143 -17.881 18.155 c -4.14 0.444 -8.056 -0.37 -11.422 -2.102 c -0.823 -0.424 -1.558 0.683 -0.885 1.319 c 4.732 4.472 11.233 7.089 18.346 6.686 c 10.796 -0.612 20.054 -8.434 22.547 -18.956 C 69.83 24.788 69.82 21.323 69.199 18.075 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.256 60.522 l 0 17.402 c 6.788 1.095 11.226 2.9 11.226 4.943 V 62.967 C 68.651 61.779 64.63 60.935 60.256 60.522 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(224,224,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.001000000000005,
    cy: 82.869,
    rx: 26.481,
    ry: 6.049,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(192,192,192)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.519 83.867 c -0.552 0 -1 -0.447 -1 -1 v -25.9 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 25.9 C 19.519 83.42 19.071 83.867 18.519 83.867 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(50,75,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.481 83.867 c -0.553 0 -1 -0.447 -1 -1 v -25.9 c 0 -0.553 0.447 -1 1 -1 s 1 0.447 1 1 v 25.9 C 72.481 83.42 72.034 83.867 71.481 83.867 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(50,75,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 89.916 c -11.047 0 -27.481 -1.877 -27.481 -7.049 S 33.953 75.818 45 75.818 s 27.481 1.877 27.481 7.049 S 56.047 89.916 45 89.916 z M 45 77.818 c -16.73 0 -25.481 3.287 -25.481 5.049 S 28.27 87.916 45 87.916 c 16.729 0 25.481 -3.287 25.481 -5.049 S 61.729 77.818 45 77.818 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(50,75,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.791 53.837 c -0.053 0 -0.106 -0.004 -0.16 -0.013 c -3.707 -0.599 -8.074 -0.915 -12.631 -0.915 c -4.556 0 -8.924 0.316 -12.63 0.915 c -0.539 0.09 -1.058 -0.282 -1.146 -0.828 c -0.088 -0.545 0.283 -1.059 0.828 -1.146 c 3.811 -0.615 8.288 -0.94 12.949 -0.94 s 9.14 0.325 12.949 0.94 c 0.546 0.088 0.916 0.602 0.828 1.146 C 58.698 53.487 58.273 53.837 57.791 53.837 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(50,75,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.481 63.755 c -0.453 0 -0.864 -0.311 -0.973 -0.771 c -0.126 -0.538 0.207 -1.076 0.744 -1.203 C 81.113 59.46 88 50.754 88 40.61 c 0 -11.822 -9.264 -21.36 -21.091 -21.715 c -0.44 -0.013 -0.82 -0.313 -0.936 -0.739 C 63.417 8.693 54.792 2.083 45 2.083 c -9.793 0 -18.418 6.609 -20.974 16.073 c -0.115 0.425 -0.495 0.726 -0.936 0.739 C 11.264 19.25 2 28.788 2 40.61 c 0 10.144 6.886 18.85 16.746 21.171 c 0.538 0.127 0.871 0.665 0.745 1.203 c -0.127 0.537 -0.669 0.865 -1.203 0.744 C 7.521 61.193 0 51.687 0 40.61 c 0 -12.665 9.735 -22.93 22.297 -23.681 C 25.319 6.974 34.551 0.083 45 0.083 c 10.448 0 19.68 6.891 22.702 16.845 C 80.265 17.68 90 27.945 90 40.61 c 0 11.077 -7.521 20.583 -18.288 23.119 C 71.635 63.746 71.558 63.755 71.481 63.755 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(50,75,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.21 31.354 c -0.431 0 -0.828 -0.28 -0.958 -0.714 c -0.665 -2.224 -1.002 -4.515 -1.002 -6.807 c 0 -13.096 10.654 -23.75 23.75 -23.75 s 23.749 10.654 23.749 23.75 c 0 0.552 -0.447 1 -1 1 s -1 -0.448 -1 -1 c 0 -11.993 -9.757 -21.75 -21.749 -21.75 c -11.993 0 -21.75 9.757 -21.75 21.75 c 0 2.098 0.309 4.196 0.918 6.234 c 0.158 0.529 -0.143 1.086 -0.672 1.244 C 23.401 31.34 23.305 31.354 23.21 31.354 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(50,75,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefsHat21086);
export default __webpack_public_path__ + "static/media/chefs-hat-21086.d00f146c340cef37fccbe19583a048c5.svg";
export { ForwardRef as ReactComponent };